<div class="llm-settings-dialog-preview-panel">
  <h1 mat-dialog-title class="llm-settings-dialog-title">Configurações do GlorIA</h1>

  <mat-dialog-content class="llm-settings-content">

    <!-- Seção Paleta de Cores -->
    <section class="llm-settings-section">
      <div class="llm-settings-label">
        <mat-icon class="llm-settings-icon-theme">color_lens</mat-icon>
        <span>Paleta de Cores</span>
      </div>
      <div class="llm-settings-palette-options">
        <div
          class="llm-settings-palette-option"
          data-theme="blue"
          (click)="selectTheme('blue')"
          matTooltip="Apenas Azul"
        >
          <div class="llm-settings-palette-swatch" id="swatch-blue"></div>
        </div>
        <div
          class="llm-settings-palette-option selected"
          data-theme="gradient"
          (click)="selectTheme('gradient')"
          matTooltip="Gradiente Azul-Violeta"
        >
          <div class="llm-settings-palette-swatch" id="swatch-gradient"></div>
        </div>
        <div
          class="llm-settings-palette-option"
          data-theme="violet"
          (click)="selectTheme('violet')"
          matTooltip="Apenas Violeta">
          <div class="llm-settings-palette-swatch" id="swatch-violet"></div>
        </div>
      </div>
    </section>

    <mat-divider></mat-divider>

    <!-- Sección Interacción por Voz -->
    <section class="llm-settings-section">
      <div class="llm-settings-item">
        <div class="llm-settings-label">
          <mat-icon class="llm-settings-icon-voice">settings_voice</mat-icon>
          <span>Interação por voz</span>
        </div>
        <mat-slide-toggle
          [(ngModel)]="voiceInteractionEnabled"
          [color]="activeToggleBackgroundColor">

        </mat-slide-toggle>
      </div>

      <div class="llm-settings-sub-settings"
           [class.visible]="voiceInteractionEnabled">
        <div class="llm-settings-item">
          <div class="llm-settings-label">
            <mat-icon class="llm-settings-icon-voice">record_voice_over</mat-icon>
            <span>De forma interativa</span>
          </div>
          <mat-slide-toggle
            [disabled]="true"
            [(ngModel)]="interactiveVoiceEnabled"
            [color]="activeToggleBackgroundColor">
          </mat-slide-toggle>
        </div>
      </div>
    </section>

    <mat-divider></mat-divider>

    <!-- Sección Tom de Voz -->
    <section class="llm-settings-section">
      <mat-form-field appearance="outline" class="llm-settings-full-width">
        <mat-label>Tom</mat-label>
        <mat-select class="llm-settings-custom-select" [(ngModel)]="selectedTone">
          <mat-option value="professional">
            <mat-icon class="llm-settings-icon-professional">work</mat-icon>
            Profissional
          </mat-option>
          <mat-option value="friendly">
            <mat-icon class="llm-settings-icon-friendly">emoji_emotions</mat-icon>
            Amistoso e cálido
          </mat-option>
          <mat-option value="informal">
            <mat-icon class="llm-settings-icon-informal">weekend</mat-icon>
            Informal e relaxado
          </mat-option>
          <mat-option value="empathetic">
            <mat-icon class="llm-settings-icon-empathetic">volunteer_activism</mat-icon>
            Empático
          </mat-option>
          <mat-option value="persuasive">
            <mat-icon class="llm-settings-icon-persuasive">campaign</mat-icon>
            Persuasivo
          </mat-option>
          <mat-option value="humorous">
            <mat-icon class="llm-settings-icon-humorous">sentiment_very_satisfied</mat-icon>
            Humorístico ou brincalhão
          </mat-option>
          <mat-option value="ceremonious">
            <mat-icon class="llm-settings-icon-ceremonious">military_tech</mat-icon>
            Cerimonioso ou respeitoso
          </mat-option>
          <mat-option value="direct">
            <mat-icon class="llm-settings-icon-direct">thumb_up</mat-icon>
            Direto mas cordial
          </mat-option>
        </mat-select>
        <mat-icon matPrefix class="llm-settings-icon-voice">support_agent</mat-icon>
      </mat-form-field>
    </section>

    <mat-divider></mat-divider>

    <!-- Sección Perfil de Usuario -->
    <section class="llm-settings-section">
      <mat-form-field appearance="outline" class="llm-settings-full-width">
        <mat-label>Nome de usuário</mat-label>
        <input
          matInput
          placeholder="Seu nome de usuário"
          [(ngModel)]="username">
        <mat-icon matPrefix class="llm-settings-icon-user">person</mat-icon>
      </mat-form-field>
    </section>

    <mat-divider></mat-divider>

    <!-- Sección Atalhos de Teclado -->
    <section class="llm-settings-section" *ngIf="_detector.isDesktop()">
      <div class="llm-settings-item">
        <div class="llm-settings-label">
          <mat-icon>keyboard</mat-icon>
          <span>Atalho de interação  </span>
        </div>
        <div class="shortcut-container" (click)="startRecordingShortcut()" matTooltip="Clique para alterar o atalho">
          <div *ngIf="!isRecordingShortcut; else recording" class="shortcut-keys-display">
            <ng-container *ngFor="let key of shortcutKeysArray; let last = last">
              <span class="shortcut-key">{{ key }}</span>
              <span *ngIf="!last" class="shortcut-plus">+</span>
            </ng-container>
          </div>
          <ng-template #recording>
            <div class="shortcut-recording-indicator">
              <span>Aperte novo atalho...</span>
            </div>
          </ng-template>
        </div>
      </div>
    </section>

    <mat-divider *ngIf="_detector.isDesktop()"></mat-divider>

    <!-- Sección Visualização de Console -->
    @if (!environment.production) {
      <section class="llm-settings-section">
        <div class="llm-settings-item">
          <div class="llm-settings-label" matTooltip="Apenas disponível fora do ambiente de produção">
            <mat-icon>terminal</mat-icon>
            <span>Visualizar console</span>
          </div>
          <mat-slide-toggle
            [(ngModel)]="consoleEnabled"
            [color]="activeToggleBackgroundColor"
          >
          </mat-slide-toggle>
        </div>

        <div class="llm-settings-sub-settings" [class.visible]="consoleEnabled">
          <div class="llm-settings-item">
            <div class="llm-settings-label">
              <mat-icon>article</mat-icon>
              <span>Log</span>
            </div>
            <mat-slide-toggle
              [(ngModel)]="logEnabled"
              [color]="activeToggleBackgroundColor">
            </mat-slide-toggle>
          </div>

          <div class="llm-settings-item">
            <div class="llm-settings-label">
              <mat-icon class="llm-settings-icon-info">bug_report</mat-icon>
              <span>Debug</span>
            </div>
            <mat-slide-toggle
              [(ngModel)]="debugEnabled" [color]="activeToggleBackgroundColor"
            >
            </mat-slide-toggle>
          </div>

          <div class="llm-settings-item">
            <div class="llm-settings-label">
              <mat-icon class="llm-settings-icon-warning">warning</mat-icon>
              <span>Warning</span>
            </div>
            <mat-slide-toggle
              [(ngModel)]="warningEnabled" [color]="activeToggleBackgroundColor"
            >
            </mat-slide-toggle>
          </div>

          <div class="llm-settings-item">
            <div class="llm-settings-label">
              <mat-icon class="llm-settings-icon-debug">error</mat-icon>
              <span>Error</span>
            </div>
            <mat-slide-toggle
              [(ngModel)]="errorEnabled" [color]="activeToggleBackgroundColor"
            >
            </mat-slide-toggle>
          </div>
        </div>
      </section>
    }

  </mat-dialog-content>

  <mat-dialog-actions align="end" class="llm-settings-dialog-actions">
    <button class="llm-settings-dialog-actions-cancel-save-settings" mat-button (click)="onCancel()">Cancelar</button>
    <button class="llm-settings-dialog-actions-save-settings" mat-raised-button (click)="saveSettings()">Salvar</button>
  </mat-dialog-actions>

</div>
